<template>
<div>
    <NavigationMenu />

    <header class="bg-gradient-to-r from-gray-700 to-gray-600 shadow-lg">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-center gap-3">
          <div class="flex items-center justify-center w-12 h-12 rounded-xl bg-white bg-opacity-20 backdrop-blur-sm">
            <i class="fas fa-users-cog text-2xl text-white"></i>
          </div>
          <div class="text-center sm:text-left">
            <h1 class="text-3xl font-bold text-white">
              Gerenciar Usuários
            </h1>
            <p class="hidden sm:block text-gray-100 text-sm mt-0.5">
              Aprovar e gerenciar novos usuários
            </p>
          </div>
        </div>
      </div>
    </header>

    <div class="container mx-auto lg:flex mt-4 justify-between px-2 sm:p-0 sm:mt-4">
        <NavigationUsers />
        
        <div class="w-full sm:w-9/12 mx-auto mr-0">
          <ApprovalTable />
        </div>
    </div>
</div>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu';
import NavigationUsers from '@/components/NavigationUsers';
import ApprovalTable from '@/components/ApprovalTable';

export default {
  name: 'ApprovalView',
  components: {
    NavigationMenu,
    NavigationUsers,
    ApprovalTable
  }
}
</script>